const $inject = ['moment'];

const guestTravellerService = function (moment) {
  const service = {};
  service.activeGuest = new Guest();

  service.addLoyaltyProgram = (programs) => {
    return programs.concat([new LoyaltyProgram()]);
  };

  service.addSecureFlightVisa = (visas) => {
    if (visas.constructor === Array && visas.length < 8) return visas.concat(new PassportOrVisa());
    else return visas;
  };

  service.removeLoyaltyProgram = (programs) => {
    return programs.slice(0, -1);
  };

  service.removeSecureFlightVisa = (visas) => {
    if (visas.constructor === Array) return visas.slice(0, -1);
    else return visas;
  };

  service.clear = () => {
    service.activeGuest = new Guest();
  };

  service.setActiveGuest = (traveller) => {
    let loyaltyPrograms = _.map(traveller.PersonalMemberships, (program) => {
      return {
        number: program.MembershipNumber,
        supplier: {
          Value: program.CompanyCode,
          Title: program.CompanyName,
          Type: program.MembershipTypeCode,
        },
      };
    });

    let customerVisas = _.map(traveller.SecureFlight.Visas, (sfi) => {
      return {
        number: sfi.Number,
        country: sfi.Country,
        expiration: sfi.IssueDate ? new Date(moment(sfi.IssueDate, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD')) : null,
      };
    });

    let customerPassport = new PassportOrVisa();
    if (traveller.SecureFlight.Passport) {
      (customerPassport.number = traveller.SecureFlight.Passport.number),
        (customerPassport.country = traveller.SecureFlight.Passport.country),
        (customerPassport.expiration = traveller.SecureFlight.Passport.expiration
          ? new Date(moment(traveller.SecureFlight.Passport.expiration, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD'))
          : null);
    }

    if (loyaltyPrograms.length === 0) {
      loyaltyPrograms = loyaltyPrograms.concat([new LoyaltyProgram()]);
    }

    if (customerVisas.length === 0) {
      customerVisas = customerVisas.concat([new PassportOrVisa()]);
    }

    service.activeGuest = _.extend(new Guest(), {
      firstName: traveller.Firstname,
      middleName: traveller.Middlename,
      lastName: traveller.Lastname,
      suffix: traveller.Suffix,
      email: traveller.Email,
      phone: traveller.Mobile,
      dob: traveller.DateOfBirth ? new Date(moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD')) : null,
      isLapChild: traveller.IsLapChild,
      gender: traveller.Gender,
      guestID: traveller.guestID,
      costCentre: {
        Code: traveller.CostCentreCode,
        Title: traveller.CostCentreName,
      },
      department: {
        Code: traveller.DepartmentCode,
        Title: traveller.DepartmentName,
      },
      loyaltyPrograms: loyaltyPrograms,
      secureFlightInfo: {
        knownTraveller: traveller.SecureFlight.KnownTraveller.toUpperCase(),
        knownTravellerCountry: traveller.SecureFlight.KnownTravellerCountry,
        redressNumber: traveller.SecureFlight.RedressNumber,
        redressCountry: traveller.SecureFlight.RedressCountry,
        passport: customerPassport,
        visas: customerVisas,
      },
    });
  };

  function Guest() {
    return {
      title: null,
      firstName: null,
      middleName: null,
      lastName: null,
      suffix: null,
      email: null,
      phone: null,
      dob: null, // don't use epoch
      gender: null,
      loyaltyPrograms: [new LoyaltyProgram()],
      secureFlightInfo: new SecureFlight(),
      costCentre: null,
      department: null,
    };
  }

  function LoyaltyProgram() {
    return {
      supplier: null,
      number: null,
    };
  }

  function PassportOrVisa() {
    return {
      number: null,
      country: null,
      expiration: null, // don't use epoch
    };
  }

  function SecureFlight() {
    return {
      knownTraveller: null,
      knownTravellerCountry: null,
      redressNumber: null,
      redressCountry: null,
      passport: new PassportOrVisa(),
      visas: [new PassportOrVisa()],
    };
  }
  service.GetAge = (dob) => {
    if (!dob) return;
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  };
  return service;
};

guestTravellerService.$inject = $inject;

export default guestTravellerService;



// WEBPACK FOOTER //
// ./src/services/guestTravellerService.js